import { Typography } from '@mui/material';

import { OfferingName } from '../../../OfferingName';

export interface PropertyNameProps {
  name: string;
}

export const PropertyDetailsHeaderName = ({ name }: PropertyNameProps) => {
  return (
    <Typography
      variant="h4.bold"
      lineHeight={1.25}
      component="h3"
      className="property-details-header-property-name"
      data-e2e="property-details-header-property-name"
    >
      <OfferingName name={name} />
    </Typography>
  );
};
